const state = {
  visible: false
}

const getters = {
  widgetSettingsVisible (state) {
    return state.visible
  }
}

const mutations = {
  setWidgetsSettingsVisibility (state, visibility) {
    state.visible = visibility
  }
}

export default {
  state,
  getters,
  mutations
}
